import React from 'react';
import { twMerge } from 'tailwind-merge';
import { InfoTip } from './InfoTip';
type FieldRowProps = {
  label: string;
  info?: boolean;
  children?: React.ReactNode;
  className?: string;
  labelClassName?: string;
};
export function FieldRow({
  label,
  info,
  children,
  className,
  labelClassName
}: FieldRowProps) {
  return <div className={twMerge('flex min-h-[29px] items-center justify-between gap-2', className)} data-id="element-823" data-mp="3atias5wlay7h">
      <div className={twMerge('flex items-center gap-[5px] text-[12px] leading-tight text-pf-muted', labelClassName)} data-id="element-824" data-mp="2x2mxmhf25uy3">
        <span data-id="element-825" data-mp="31vg2r6efv5ap">{label}</span>
        {info && <InfoTip label={`About ${label}`} data-id="element-826" data-mp="2n5iih1jmqzqs" />}
      </div>
      {children}
    </div>;
}